﻿import { Dialog as MuiDialog, DialogProps } from '@mui/material';
import React from 'react';

function Dialog(props: DialogProps) {
  const { children } = props;
  return <MuiDialog {...props}>{children}</MuiDialog>;
}
export default Dialog;
